export const routes = {
  auth: {
    landing: "/",
    login: "/login",
    register: "/register/:programTypeId/:departmentId/:id",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    verifyEmail: "/verify-email",
  },
  main: {
    home: "/admission",
    contactUs: "/contact-us",
    studentLife: "/student-life",
    courseDetails: "/course-details/:id/:programTypeId",
    aboutUs: "/about-us",
  },
  dashboard: {
    bioData: "/bio-data",
    workHistory: "/work-history",
    requiredDocuments: "/required-documents",
    scholarship: "/scholarship",
    viewWorkHistory: "/view-work-history/:id",
    institute: "/institute",
    viewInstitute: "/view-institute/:id",
    payments: "/payments",
   paymentStatus: "/payment-status",
    utmeResult: "/utme-result",
    viewQualification: "/view-qualification/:id",
    dashboard: "/dashboard",
    paymentReceipt: "/payment-receipt",
    applicationStatus: "/application-status",
    applicationForm: "/application-form",
    admissionStatus: "/admission-status",
    changePassword: "/change-password",
  },
  onboarding: "/onboarding",
  fileUpload: {
    referenceUpload: "/referenceUpload"
  }
};

